import Icon from '../components/Icon.vue'

Icon.register({
  feather: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M467.1 44.8C404.6-17.6 305.5-19.9 214.9 70.6 136.3 149.1 153.9 131.5 129.1 156.2 68.7 216.6 58.7 307.1 65.5 367.4L243.9 189.1C250.2 182.9 260.3 182.9 266.6 189.1S272.8 205.5 266.6 211.8L7 471C-2.3 480.4-2.3 495.6 7 505 16.4 514.3 31.6 514.3 41 505L107.1 438.9C159.4 454.6 279 457.1 353.9 384H255.8L403.3 334.9C453.3 284.9 439.7 298.7 449.6 288H351.9L483.4 244.2C528.8 169.7 517.7 95.4 467.1 44.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/feather.js
// module id = pRRp
// module chunks = 144